import { CARD_FORM } from '../form-card-type';
import { formatDate } from '../../../../helpers/helpers';
import { showToast } from '../../../toasts';
import { displaySelectedValue } from '../../../dropdown';
import { individualCardPrint } from '../csv/individual-csv';

import { ICards } from '../../../../models/cards.interface';

/**
 * Function to display individual Card information
 * 
 * @param {ICards[]} data the incoming AWS data
 * 
 * @returns void
 */
export const displayCardInfo = (data: ICards[]) => {
  const { customerId, cardNumber, cardName, cardGroupId, status, LastTransaction } = data[0];

  CARD_FORM.cardNumber.value = cardNumber;
  CARD_FORM.cardNames.value = cardName;
  CARD_FORM.cardTransaction.value = formatDate(LastTransaction);
  CARD_FORM.cardDriverPins.value = '--';

  displaySelectedValue('.aafp_list-active', 'active', String(status));
  displaySelectedValue('.aafp_list-customer', 'customer', String(customerId));
  displaySelectedValue('.aafp_list-card-group', 'card-group', String(cardGroupId));

  if( !CARD_FORM.printButton ) return;

  CARD_FORM.printButton.addEventListener('click', () => {
    if ( status !== 0 ) {
      CARD_FORM.printButton.classList.add('aafp_button-loading');
      individualCardPrint(data[0]);
    } else {
      showToast('aafp_toast-alert', 'This card is inactive. Please activate the card before printing.');
    }    
  });
}